"use client";

import React from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  Grid,
  Card,
  CardContent,
  CardActions,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function PlanModal({ open, onClose, plans, onSelectPlan }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 520 },
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 3,
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={2}>
          Select a Subscription Plan
        </Typography>

        <Grid container spacing={2}>
          {plans?.data?.map((plan) => (
            <Grid item xs={12} key={plan.id}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  transition: "0.2s",
                  cursor: "pointer",
                  "&:hover": {
                    borderColor: "primary.main",
                    boxShadow: 2,
                  },
                }}
              >
                <CardContent>
                  {/* Header */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography variant="subtitle1" fontWeight={600}>
                      {plan.name}
                    </Typography>
                    <Chip
                      label={plan.topUpPeriod}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  </Box>

                  {/* Price */}
                  <Typography variant="h5" fontWeight={700} color="primary">
                    {plan.price}
                  </Typography>

                  {/* Description */}
                  <Typography variant="body2" color="text.secondary" mt={1}>
                    {plan.description}
                  </Typography>

                  {/* Features */}
                  <List dense sx={{ mt: 1 }}>
                    {plan.features?.map((feature, index) => (
                      <ListItem key={index} disableGutters>
                        <ListItemIcon sx={{ minWidth: 30 }}>
                          <CheckCircleOutlineIcon
                            fontSize="small"
                            color="success"
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={feature}
                          primaryTypographyProps={{
                            variant: "body2",
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>

                {/* Actions */}
                <CardActions sx={{ px: 2, pb: 2 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => onSelectPlan(plan)}
                  >
                    Choose Plan
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Footer */}
        <Button
          fullWidth
          variant="outlined"
          color="secondary"
          onClick={onClose}
          sx={{ mt: 3 }}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
}
